(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddQuestionComponentFields', directive);

    directive.$inject = ['modalService', 'oddQuestionnaireTemplateService'];

    function directive(modalService, oddQuestionnaireTemplateService) {
        return {
            restrict: 'E',
            scope: {
                question: '=',
                questionFieldTypes: '=',
                disabled: '=?',
                helpText: '&'
            },
            require: ['^form'],
            templateUrl: require('./oddQuestionComponentFields.tpl.html'),
            link: function ($scope, $element, $attrs, $ctrl) {
                $scope.form = $ctrl[0];
                $scope.validate();
            },
            controller: ['$rootScope', '$scope', '$timeout', function ($rootScope, $scope, $timeout) {
                $scope.helpText = $scope.helpText();
                $scope.questionFieldTypesById = _.keyBy($scope.questionFieldTypes, 'ODDQuestionTypeID');

                $scope.ctrlCtxt = {
                    allowFieldGroupMax: false,
                    fieldGroupMaxMinValue: 1
                };

                $scope.add = add;
                $scope.openAdd = openAdd;
                $scope.remove = remove;
                $scope.validate = validate;

                $scope.$watch('question', function () {
                    initFieldComponents();
                });

                $scope.labelUpdated = function () {
                    var labels = {};

                    $scope.question.ODDQuestionFields.forEach(function (field, index) {
                        labels[field.TitleEN] = labels[field.TitleEN] || [];
                        labels[field.TitleEN].push(index);
                    });

                    _.forOwn(labels, function (indexes) {
                        indexes.forEach(function (idx) {
                            if ($scope.form['formField.' + idx].fieldLabel) {
                                $scope.form['formField.' + idx].fieldLabel.$setValidity('ODDUniqueFieldLabel', indexes.length < 2);
                            } else {
                                _.forEach($scope.question.ODDQuestionFields[idx].ODDQuestionAttachments, function (attachComp, attachmentIndex) {
                                    $scope.form['formField.' + idx]['attachmentLabel.'+attachmentIndex].$setValidity('ODDUniqueFieldLabel', indexes.length < 2);
                                });
                            }
                        });
                    });
                };

                $scope.fieldRequirement = function (field) {
                    if (!$scope.question.ODDQuestionFields.length) return false;

                    // Set Question Attribute Values
                    if (field && field.ODDQuestionAttributeValues) {
                        var idx = _.findIndex(field.ODDQuestionAttributeValues, {Code: 'IsMandatory'});
                        if (idx > -1) {
                            field.ODDQuestionAttributeValues[idx].ValueText = _.toString(field.IsRequired);
                        } else {
                            console.warn('Missing ODDAttributeValue: IsMandatory for field ' + field.ODDQuestionComponentFieldID);
                        }
                    } else if (field) {
                        console.warn('Missing ODDAttributeValues on field ' + field.ODDQuestionComponentFieldID);
                    }

                    // Make sure that at least one field is required
                    var oneRequired = false;

                    $scope.question.ODDQuestionFields.some(function (qField) {
                        if (qField.ODDQuestionAttributeValues) {
                            qField.ODDQuestionAttributeValues.some(function (attrValue) {
                                if (attrValue.Code === "IsMandatory") {
                                    if (attrValue.ValueText === 'true') {
                                        oneRequired = true;
                                    }
                                    return true;
                                }
                                return false;
                            })
                        }
                        return oneRequired;
                    });
                    $scope.form.$setValidity('ODDRequiredField', oneRequired);
                };

                $scope.isFieldMandatory = function (field) {
                    var mandatoryAttr = _.find(field.ODDQuestionAttributeValues, {Code: 'IsMandatory'});
                    if (_.isUndefined(mandatoryAttr)) {
                        console.error('Field ' + field.ODDQuestionComponentFieldID + 'does not have a IsMandatory ODDQuestionAttributeValue.');
                        return false;
                    }
                    return mandatoryAttr === 'true';
                };


                /* Field Group limits */

                // Min
                $scope.ctrlCtxt.fieldGroupMinAttrIndex =
                    _.findIndex($scope.question.ODDQuestionAttributeValues, {'Code': 'MinFieldGroupInstances'});

                $scope.ctrlCtxt.fieldGroupMin =
                    Number(_.get($scope.question.ODDQuestionAttributeValues[$scope.ctrlCtxt.fieldGroupMinAttrIndex], 'ValueText', -1));

                // If unlimited, default to 1 when showing min input
                if ($scope.ctrlCtxt.fieldGroupMin === -1) {
                    $scope.ctrlCtxt.fieldGroupMin = 1;
                }

                // fieldGroupMinChanged
                $scope.fieldGroupMinChanged = function () {
                    $scope.ctrlCtxt.fieldGroupMin = Math.floor($scope.ctrlCtxt.fieldGroupMin);

                    if ($scope.ctrlCtxt.fieldGroupMin > $scope.ctrlCtxt.fieldGroupMax) {
                        $scope.ctrlCtxt.fieldGroupMax = $scope.ctrlCtxt.fieldGroupMin;
                    }
                    $scope.question.ODDQuestionAttributeValues[$scope.ctrlCtxt.fieldGroupMinAttrIndex].ValueText =
                        String.valueOf()($scope.ctrlCtxt.fieldGroupMin);
                };

                // Max
                $scope.ctrlCtxt.fieldGroupMaxAttrIndex =
                    _.findIndex($scope.question.ODDQuestionAttributeValues, {'Code': 'MaxFieldGroupInstances'});

                $scope.ctrlCtxt.fieldGroupMax =
                    Number(_.get($scope.question.ODDQuestionAttributeValues[$scope.ctrlCtxt.fieldGroupMaxAttrIndex], 'ValueText', -1));

                $scope.ctrlCtxt.allowFieldGroupMax = $scope.ctrlCtxt.fieldGroupMax > -1;

                // If unlimited, default to min when showing max input
                if ($scope.ctrlCtxt.fieldGroupMax === -1) {
                    $scope.ctrlCtxt.fieldGroupMax = $scope.ctrlCtxt.fieldGroupMin;
                }

                // allowFieldGroupMaxChanged
                $scope.allowFieldGroupMaxChanged = function () {
                    if (!$scope.ctrlCtxt.allowFieldGroupMax) {
                        $scope.question.ODDQuestionAttributeValues[$scope.ctrlCtxt.fieldGroupMaxAttrIndex].ValueText = '-1';
                    } else {
                        $scope.question.ODDQuestionAttributeValues[$scope.ctrlCtxt.fieldGroupMaxAttrIndex].ValueText =
                            String.valueOf()($scope.ctrlCtxt.fieldGroupMax);
                    }
                };

                // fieldGroupMaxChanged
                $scope.fieldGroupMaxChanged = function () {
                    $scope.ctrlCtxt.fieldGroupMax = Math.floor($scope.ctrlCtxt.fieldGroupMax);

                    if ($scope.ctrlCtxt.fieldGroupMax < $scope.ctrlCtxt.fieldGroupMin) {
                        $scope.ctrlCtxt.fieldGroupMin = $scope.ctrlCtxt.fieldGroupMax;
                    }
                    $scope.question.ODDQuestionAttributeValues[$scope.ctrlCtxt.fieldGroupMaxAttrIndex].ValueText =
                        String.valueOf()($scope.ctrlCtxt.fieldGroupMax);
                };


                function initFieldComponents() {
                    if (!$scope.question.ODDQuestionFields) return;

                    $scope.question.ODDQuestionFields.forEach(function (field) {
                        var isMandatoryAttribute = _.find(field.ODDQuestionAttributeValues, {Code: 'IsMandatory'});
                        if (isMandatoryAttribute) {
                            field.IsRequired = isMandatoryAttribute.ValueText === 'true';
                        } else {
                            console.warn('Question Field does not have an ODDQuestionAttributeValue for code IsMandatory');
                        }
                    });
                }

                function validate() {
                    var hasFields = !!($scope.question.ODDQuestionFields  && $scope.question.ODDQuestionFields.length > 0);

                    $scope.form.$setValidity('ODDQuestionFields', hasFields);

                    $scope.fieldRequirement();
                }

                function openAdd() {
                    // Fetch types
                    oddQuestionnaireTemplateService.getQuestionFieldTypes()
                        .then(function (questionTypes) {
                            var modal = modalService.displayTemplateModal(
                                'Select a Field Type',
                                require('./oddQuestionType.modal.tpl.html'),
                                {
                                    questionTypes: questionTypes,
                                    ctrl: { step: 'questionTypes' },
                                    onQuestionTypeSelection: function(ctrl, questionType) {
                                        ctrl.questionType = questionType;

                                        if (questionType.Code === 'FieldMultipleChoice') {
                                            ctrl.step = 'multipleChoiceTemplates';
                                            modal.$scope.title = 'Select a ' + questionType.TitleEN + ' Template';

                                            oddQuestionnaireTemplateService.getQuestionMultiChoiceTemplates().then(function(multiChoiceTemplates) {
                                                ctrl.multiChoiceTemplates = multiChoiceTemplates;
                                            });

                                            return;
                                        }

                                        modal.$promise.then(modal.hide);
                                        add(ctrl.questionType);
                                    },
                                    onUserDefinedMultiChoiceSelection: function(ctrl) {
                                        modal.$promise.then(modal.hide);
                                        add(ctrl.questionType);
                                    },
                                    onMultiChoiceTemplateSelection: function(ctrl, multiChoiceTemplate) {
                                        modal.$promise.then(modal.hide);
                                        add(ctrl.questionType, multiChoiceTemplate);
                                    }
                                },
                                false
                            )
                        });
                }

                function add(type, multiChoiceTemplate) {
                    if (!$scope.question.ODDQuestionFields) {
                        $scope.question.ODDQuestionFields = [];
                    }

                    var questionComponent = {
                        ODDQuestionTypeID: type.ODDQuestionTypeID,
                        ODDQuestionType: type,
                        ODDQuestionAttributeValues: _.cloneDeep(type.ODDQuestionAttributeValues),
                        IsRequired: Boolean(_.find(type.ODDQuestionAttributeValues, {Code: 'IsMandatory'}).ValueText)
                    };

                    if (multiChoiceTemplate) {
                        questionComponent.ODDQuestionChoiceTemplate = multiChoiceTemplate;
                        questionComponent.ODDQuestionChoiceTemplateID = multiChoiceTemplate.ODDQuestionChoiceTemplateID;
                    }

                    $scope.question.ODDQuestionFields.push(questionComponent);
                    $scope.form.$setDirty();
                    validate();

                    $timeout(function () {
                        $scope.$broadcast('focus.field.' + ($scope.question.ODDQuestionFields.length - 1));
                    });
                }

                function remove(index) {
                    $scope.question.ODDQuestionFields.splice(index, 1);
                    $scope.form.$setDirty();
                    validate();
                }
            }]
        }
    }
})();
